import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import { connect } from 'react-redux';
import Breadcrumbs from '@cotyorg/ccx-molecules/Breadcrumbs';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import Link from '@cotyorg/ccx-atoms/Link';
import Icon from '@cotyorg/ccx-atoms/Icon';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import StandardLayout from '../../templates/StandardLayout';
import SectionHeader from '../../atoms/SectionHeader';

const WhereToBuyComponent = ({
  breadcrumb,
  sectionHeadings,
  links,
  ctaText,
}) => (
  <StandardLayout>
    <Breadcrumbs items={breadcrumb} />

    <SectionHeader extraClass="wtb-section-header">
      <div className="grid-container">
        <div className="grid-x">
          <div className="cell">
            <Heading level={2} extraClass="wtb-section-header__heading">
              {R.path(['pageHeaderSection', 'heading'], sectionHeadings)}
            </Heading>

            <OptionalSection
              renderCondition={R.hasPath(
                ['pageHeaderSection', 'subheading'],
                sectionHeadings
              )}
              section={() => (
                <Paragraph extraClass="wtb-section-header__subheading">
                  {R.path(['pageHeaderSection', 'subheading'], sectionHeadings)}
                </Paragraph>
              )}
            />
          </div>
        </div>
      </div>
    </SectionHeader>

    <div className="grid-container">
      <div className="grid-x">
        <div className="cell medium-14 medium-offset-1 large-12 large-offset-2">
          {R.map(
            (link) => (
              <Link
                key={R.prop('href', link)}
                title={R.prop('title', link)}
                link={R.prop('href', link)}
                extraClass="wtb-link"
                target="_blank"
              >
                <Heading level={3}>{R.prop('title', link)}</Heading>

                <Heading level={5}>
                  <span className="show-for-medium">{ctaText}</span>
                  <Icon
                    iconSrc="/ccx-files/assets/chevron-right.svg"
                    size="medium"
                    extraClass="wtb-link__icon"
                  />
                </Heading>
              </Link>
            ),
            links
          )}
        </div>
      </div>
    </div>
  </StandardLayout>
);

WhereToBuyComponent.propTypes = {
  breadcrumb: PropTypes.arrayOf(PropTypes.object).isRequired,
  sectionHeadings: PropTypes.objectOf(PropTypes.object).isRequired,
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
  ctaText: PropTypes.string.isRequired,
};

export default connect(({ content }) => ({
  breadcrumb: R.prop('breadcrumb', content),
  sectionHeadings: R.prop('sectionHeadings', content),
  links: R.prop('links', content),
  ctaText: R.prop('ctaText', content),
}))(WhereToBuyComponent);
